import { useNavigation } from '@/navigation/NavigationContex';
import { AccordionItem } from '../../components/AccordionItem';
import { AccordionItemContent } from '../../components/AccordionItemContent';
import { AccordionItemHeader } from '../../components/AccordionItemHeader';
import { translate } from '@/translation/translate.ts';
import { RenderField } from '@/form/fields/RenderField';

const AncestryHawaiian = () => {
  const { currentSlide } = useNavigation();

  const ancestryGuamanian = currentSlide!.fields.find(({ name }) => name === 'ancestryGuamanian');
  const ancestrySamoan = currentSlide!.fields.find(({ name }) => name === 'ancestrySamoan');
  const ancestryHawaiian = currentSlide!.fields.find(({ name }) => name === 'ancestryHawaiian');
  const ancestryOtherNativeHawaiian = currentSlide!.fields.find(({ name }) => name === 'ancestryOtherNativeHawaiian');

  return (
    <AccordionItem>
      <AccordionItemHeader>{translate(currentSlide?.titles?.hawaiian)}</AccordionItemHeader>
      <AccordionItemContent>
        <RenderField slideId={currentSlide!.id} field={ancestryGuamanian!} />
        <RenderField slideId={currentSlide!.id} field={ancestrySamoan!} />
        <RenderField slideId={currentSlide!.id} field={ancestryHawaiian!} />
        <RenderField slideId={currentSlide!.id} field={ancestryOtherNativeHawaiian!} />
      </AccordionItemContent>
    </AccordionItem>
  );
};

export default AncestryHawaiian;
